import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { api, API } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { logError } from "@/lib/logger";
import { money, statusClass, paymentClass, formatDate } from "@/lib/utils-app";
import { ChevronRight, Download } from "lucide-react";

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/my/orders"); setOrders(data); }
      catch (err) { logError("[customer-dashboard] failed to load orders:", err); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Minha conta</div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Olá, {user?.name?.split(" ")[0]}</h1>
        <p className="mt-3 text-neutral-600">Histórico de serviços vinculados ao seu CPF ou e-mail.</p>

        <div className="mt-10 space-y-3">
          {loading && <div className="text-sm text-neutral-500">Carregando…</div>}
          {!loading && orders.length === 0 && (
            <div className="border border-neutral-200 rounded-2xl p-8 bg-white text-center text-neutral-500">
              Nenhuma OS encontrada. Você pode <Link to="/" className="underline font-semibold text-neutral-900">rastrear</Link> uma OS pelo código.
            </div>
          )}
          {orders.map((o) => (
            <div
              key={o.os_code}
              className="bg-white border border-neutral-200 rounded-xl p-5 hover:border-neutral-900 hover:-translate-y-0.5 transition-all flex items-center justify-between gap-4"
              data-testid={`my-os-${o.os_code}`}
            >
              <Link to={`/rastrear/${o.os_code}`} className="flex-1 min-w-0">
                <div className="font-mono font-bold">{o.os_code}</div>
                <div className="text-sm text-neutral-600 mt-1">{o.device_brand} {o.device_model}</div>
                <div className="text-xs text-neutral-500 mt-1">{formatDate(o.created_at)}</div>
              </Link>
              <div className="flex flex-col gap-2 items-end">
                <span className={statusClass(o.status)}>● {o.status}</span>
                {o.status === "Serviço Concluído" && <span className={paymentClass(o.payment_status)}>● {o.payment_status}</span>}
                <div className="font-mono font-bold mt-1">{money(o.total)}</div>
              </div>
              {o.payment_status === "Pago" ? (
                <button onClick={() => window.open(`${API}/receipts/${o.os_code}`, "_blank")} className="text-neutral-400 hover:text-neutral-900" data-testid={`receipt-${o.os_code}`} title="Baixar recibo">
                  <Download size={18} />
                </button>
              ) : (
                <ChevronRight size={16} className="text-neutral-400" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
